import ScalarSidebarGroupToggle_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarGroupToggle.vue.script.js";
//#region src/components/ScalarSidebar/ScalarSidebarGroupToggle.vue
var ScalarSidebarGroupToggle_default = ScalarSidebarGroupToggle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarGroupToggle_default as default };

//# sourceMappingURL=ScalarSidebarGroupToggle.vue.js.map